import { Component, Input, ViewChild } from '@angular/core';
import { ClassificationService } from '../../../../services/classification.service';
import { ClassificationOverviewDetail } from '../../../../model/classification-overview-detail';
import { ClassificationConfigurationSection } from './configuration';
import { LoadingController } from 'ionic-angular';
import { Observable } from 'rxjs';
import { ClassificationContestantAllData } from '../../../../model/classification-all-contestant-data';
import { ClassificationHorseAllData } from '../../../../model/classification-all-horse-data';
import { ClassificationConfiguration } from '../../../../model/classification-configuration';

@Component({
    selector: 'admin-classifications',
    templateUrl: 'classifications.html'
})
export class ClassificationSection {
    @Input('viewMode') viewMode: string;
    @ViewChild('configuration') configuration: ClassificationConfigurationSection;

    loadingData: boolean;

    peopleOverviewData: Map<string, number> = new Map<string, number>();
    horseOverviewData: Map<string, number> = new Map<string, number>();
    runOverviewData: Map<string, number> = new Map<string, number>();
    eventOverviewData: Map<string, number> = new Map<string, number>();

    peopleData: ClassificationOverviewDetail[];
    horseData: ClassificationOverviewDetail[];
    runData: ClassificationOverviewDetail[];
    eventData: ClassificationOverviewDetail[];

    contestantOneData: ClassificationContestantAllData[] = [];
    contestantTwoData: ClassificationContestantAllData[] = [];
    horseOneData: ClassificationHorseAllData[] = [];
    horseTwoData: ClassificationHorseAllData[] = [];

    entrySearchChangeObservable;
    totalClassificationResults: number = 0;

    handicap: number;
    firstName: string;
    lastName: string;
    rodeoEventFilter: string;
    selectedRole: string = "Contestant One";
    columnsToShow: string[];

    selectedDiscipline: string = 'All';
    selectedHandicap: string = 'All';
    disciplines: string[];
    handicaps: any[];

    configurations: ClassificationConfiguration[];
    selectedConfiguration: ClassificationConfiguration;
    classificationResults: any[] = [];

    rodeoEventAllData: any[];

    sortByName = '';
    sortByHandicap = '';
    sortByScore = '';
    sortByHiddenScore = '';
    sortByRuns = '';

    constructor(public classificationService: ClassificationService, public loadingCtrl: LoadingController) {

    }

    load() {
        let loader = this.loadingCtrl.create({
            content: "Loading classification data..."
        });
        loader.present();

        this.loadingData = true;

        this.classificationService.getOverviewData()
            .then(data => {
                this.peopleData = (data as any).people;
                this.horseData = (data as any).horses;
                this.runData = (data as any).runs;
                this.eventData = (data as any).rodeoEvents;
                this.disciplines = (data as any).disciplines;

                loader.dismiss();
            })
            .catch((err) => {
                this.loadingData = false;
                console.error(err);
                loader.dismiss();
            })

        this.classificationService.getConfigurations()
            .then(data => {
                this.configurations = (data as ClassificationConfiguration[]);

                if (this.configurations && this.configurations.length > 0) {
                    this.selectedConfiguration = this.configurations[0];
                    this.selectedDiscipline = this.selectedConfiguration.eventType;
                } else {
                    var newConfiguration = new ClassificationConfiguration();
                    newConfiguration.weights = [];
                    newConfiguration.expectations = [];

                    this.configurations = [];
                    this.configurations.push(newConfiguration);
                }
                this.loadingData = false;
            })
            .catch((err) => {
                this.loadingData = false;
                console.error(err);
            })
    }

    loadClassifications() {
        let loader = this.loadingCtrl.create({
            content: "Loading " + this.selectedDiscipline + " classification data..."
        });
        loader.present();

        var request = {
            horse: this.selectedRole.indexOf('Horse') != -1,
            firstName: this.firstName,
            lastName: this.lastName
        }

        this.rodeoEventAllData = [];

        this.classificationService.getClassifications(this.selectedConfiguration.id, request)
            .then(data => {
                this.contestantOneData = (data as any).contestantOneData;
                this.contestantTwoData = (data as any).contestantTwoData;
                this.horseOneData = (data as any).horseOneData;
                this.horseTwoData = (data as any).horseTwoData;

                var maxHandicap = Math.max(...this.selectedConfiguration.expectations.map(x => x.handicap));

                this.contestantOneData.forEach((allData) => {
                    allData.rodeoEventData.forEach((rodeoEventData) => {
                        if (!this.rodeoEventAllData[rodeoEventData.rodeoEventId]) {
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId] = {};
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId].totalRuns = 0;
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId].fastTime = ((rodeoEventData as any).rawActualOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == maxHandicap)[0].rawActualTime).toFixed(3);
                        }

                        this.rodeoEventAllData[rodeoEventData.rodeoEventId].totalRuns += rodeoEventData.rawRunCount;
                        (rodeoEventData as any).expectedCatch = ((rodeoEventData as any).catchOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == allData.handicap)[0].catch).toFixed(2);
                        (rodeoEventData as any).expectedError = ((rodeoEventData as any).errorOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == allData.handicap)[0].error).toFixed(2);
                        (rodeoEventData as any).expectedRawActual = ((rodeoEventData as any).rawActualOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == allData.handicap)[0].rawActualTime + .15).toFixed(3);
                        (rodeoEventData as any).expectedSplit = ((rodeoEventData as any).splitOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == allData.handicap)[0].split).toFixed(3);

                        (rodeoEventData as any).columns = [];
                        (rodeoEventData as any).columns.push(['Error', (rodeoEventData as any).errorWeightedScore, '(' + (rodeoEventData as any).errorScore + ')']);
                        (rodeoEventData as any).columns.push(['Raw Actual', (rodeoEventData as any).rawActualWeightedScore, '(' + (rodeoEventData as any).rawActualScore + ')']);
                        //(rodeoEventData as any).columns.push(['Win',((rodeoEventData as any).winOdds * 100) + '%', '']);
                        (rodeoEventData as any).columns.push(['Score',(rodeoEventData as any).weightedScore, '(' + (rodeoEventData as any).score + ')']);
                    })
                });

                this.horseOneData.forEach((allData) => {
                    allData.rodeoEventData.forEach((rodeoEventData) => {
                        if (!this.rodeoEventAllData[rodeoEventData.rodeoEventId]) {
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId] = {};
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId].totalRuns = 0;
                            this.rodeoEventAllData[rodeoEventData.rodeoEventId].fastTime = ((rodeoEventData as any).rawActualOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == false
                                && y.handicap == maxHandicap)[0].rawActualTime).toFixed(3);
                        }

                        (rodeoEventData as any).expectedCatch = ((rodeoEventData as any).catchOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == true
                                && y.handicap == allData.handicap)[0].catch).toFixed(2);
                        (rodeoEventData as any).expectedError = ((rodeoEventData as any).errorOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == true
                                && y.handicap == allData.handicap)[0].error).toFixed(2);
                        (rodeoEventData as any).expectedRawActual = ((rodeoEventData as any).rawActualOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == true
                                && y.handicap == allData.handicap)[0].rawActualTime + .15).toFixed(3);
                        (rodeoEventData as any).expectedSplit = ((rodeoEventData as any).splitOffset +
                            this.selectedConfiguration.expectations.filter(y => y.positionOne == true && y.horse == true
                                && y.handicap == allData.handicap)[0].split).toFixed(3);

                        (rodeoEventData as any).columns = [];
                        (rodeoEventData as any).columns.push(['Error', (rodeoEventData as any).errorWeightedScore, '(' + (rodeoEventData as any).errorScore + ')']);
                        (rodeoEventData as any).columns.push(['Raw Actual', (rodeoEventData as any).rawActualWeightedScore, '(' + (rodeoEventData as any).rawActualScore + ')']);
                        //(rodeoEventData as any).columns.push(['Win',(rodeoEventData as any).winOdds, '']);
                        (rodeoEventData as any).columns.push(['Score',(rodeoEventData as any).weightedScore, '(' + (rodeoEventData as any).score + ')']);
                    })
                });

                loader.dismiss();
                this.filterEntries();
            })
            .catch((err) => {
                this.loadingData = false;
                loader.dismiss();
                console.error(err);
            })
    }

    onFirstNameSearchChange(searchValue: string) {
        this.onClassificationSearchChange('firstName' + searchValue);
    }

    onLastNameSearchChange(searchValue: string) {
        this.onClassificationSearchChange('lastName' + searchValue);
    }

    onSelectedRoleChange() {        
        this.onClassificationSearchChange('role' + this.selectedRole);
    }

    onHandicapChange() {
        this.onClassificationSearchChange('handicapFilter' + this.selectedHandicap);
    }

    onEventFilterChange() {
        this.onClassificationSearchChange('eventFilter' + this.selectedDiscipline);
    }

    onClassificationSearchChange(searchValue: string) {
        if (!this.entrySearchChangeObservable) {
            Observable.create(observer => {
                this.entrySearchChangeObservable = observer;
            }).debounceTime(300)
                .distinctUntilChanged()
                .subscribe((text) => { this.filterEntries() });
        }

        this.entrySearchChangeObservable.next(searchValue);
    }

    filterEntries() {
        this.selectedConfiguration = this.configurations.filter(x => x.eventType == this.selectedDiscipline)[0];
        this.handicaps = [];
        this.selectedConfiguration.expectations.forEach(x => {
            this.handicaps.push(x.handicap);
        })

        this.classificationResults = [];

        if (this.selectedRole == 'Contestant One') {
            this.totalClassificationResults = this.contestantOneData.length;
            this.classificationResults = this.contestantOneData;
        } else if (this.selectedRole == 'Contestant Two') {
            this.totalClassificationResults = this.contestantTwoData.length;
            this.classificationResults = this.contestantTwoData;
        } else if (this.selectedRole == 'Horse One') {
            this.totalClassificationResults = this.horseOneData.length;
            this.classificationResults = this.horseOneData;
        } else if (this.selectedRole == 'Horse Two') {
            this.totalClassificationResults = this.horseTwoData.length;
            this.classificationResults = this.horseTwoData;
        }

        if (this.selectedHandicap != 'All') {
            console.log("filtering handicap....");
            this.classificationResults = this.classificationResults.filter(x => x.handicap == this.selectedHandicap);
        }

        if (this.firstName) {
            console.log("filtering firstName....");
            this.classificationResults = this.classificationResults.filter(x => x.account ? x.account.firstName.toLowerCase().indexOf(this.firstName.toLowerCase()) != -1 : x.horse.name.toLowerCase().indexOf(this.firstName.toLowerCase()) != -1)
        }

        if (this.lastName) {
            console.log("filtering lastName....");
            this.classificationResults = this.classificationResults.filter(x => x.account ? x.account.lastName.toLowerCase().indexOf(this.lastName.toLowerCase()) != -1 : true)
        }

        console.log("filtering entries....");

        this.sortEntries();
    }

    toggleNameSort() {
        if (this.sortByName == '')
            this.sortByName = 'asc';
        else if (this.sortByName == 'asc')
            this.sortByName = 'desc'
        else
            this.sortByName = '';

        this.filterEntries();
    }

    toggleHandicapSort() {
        if (this.sortByHandicap == '')
            this.sortByHandicap = 'asc';
        else if (this.sortByHandicap == 'asc')
            this.sortByHandicap = 'desc'
        else
            this.sortByHandicap = '';

        this.filterEntries();
    }

    toggleScoreSort() {
        if (this.sortByScore == '')
            this.sortByScore = 'asc';
        else if (this.sortByScore == 'asc')
            this.sortByScore = 'desc'
        else
            this.sortByScore = '';

        this.filterEntries();
    }

    toggleHiddenScoreSort() {
        if (this.sortByHiddenScore == '')
            this.sortByHiddenScore = 'asc';
        else if (this.sortByHiddenScore == 'asc')
            this.sortByHiddenScore = 'desc'
        else
            this.sortByHiddenScore = '';

        this.filterEntries();
    }

    toggleRunsSort() {
        if (this.sortByRuns == '')
            this.sortByRuns = 'asc';
        else if (this.sortByRuns == 'asc')
            this.sortByRuns = 'desc'
        else
            this.sortByRuns = '';

        this.filterEntries();
    }

    sortEntries() {
        if (this.sortByName == 'asc') {
            this.classificationResults.sort((a, b) => {
                if (a.horse) {
                    return a.horse.name < b.horse.name ? -1 : 1;
                } else {
                    return a.account.firstName < b.account.firstName ? -1 : 1;
                }
            });
        } else if (this.sortByName == 'desc') {
            this.classificationResults.sort((a, b) => {
                if (a.horse) {
                    return a.horse.name < b.horse.name ? 1 : -1;
                } else {
                    return a.account.firstName < b.account.firstName ? 1 : -1;
                }
            });
        }

        if (this.sortByHandicap == 'asc') {
            this.classificationResults.sort((a, b) => {
                return a.handicap < b.handicap ? -1 : 1;
            });
        } else if (this.sortByHandicap == 'desc') {
            this.classificationResults.sort((a, b) => {
                return a.handicap < b.handicap ? 1 : -1;
            });
        }

        if (this.sortByScore == 'asc') {
            this.classificationResults.sort((a, b) => {
                return a.score < b.score ? -1 : 1;
            });
        } else if (this.sortByScore == 'desc') {
            this.classificationResults.sort((a, b) => {
                return a.score < b.score ? 1 : -1;
            });
        }

        if (this.sortByHiddenScore == 'asc') {
            this.classificationResults.sort((a, b) => {
                return a.hiddenScore < b.hiddenScore ? -1 : 1;
            });
        } else if (this.sortByHiddenScore == 'desc') {
            this.classificationResults.sort((a, b) => {
                return a.hiddenScore < b.hiddenScore ? 1 : -1;
            });
        }

        if (this.sortByRuns == 'asc') {
            this.classificationResults.sort((a, b) => {
                return a.rawRunCount < b.rawRunCount ? -1 : 1;
            });
        } else if (this.sortByRuns == 'desc') {
            this.classificationResults.sort((a, b) => {
                return a.rawRunCount < b.rawRunCount ? 1 : -1;
            });
        }
    }

    onDisciplineFilterChange() {

    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/classification/classifications.ts